import { render } from "./mobileBar.vue?vue&type=template&id=07d737c7&scoped=true"
import script from "./mobileBar.vue?vue&type=script&lang=js"
export * from "./mobileBar.vue?vue&type=script&lang=js"

import "./mobileBar.vue?vue&type=style&index=0&id=07d737c7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d737c7"]])

export default __exports__